(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "../hooks", "../hooks/useRouteLocation", "react/jsx-runtime"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("../hooks"), require("../hooks/useRouteLocation"), require("react/jsx-runtime"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.hooks, global.useRouteLocation, global.jsxRuntime);
    global.Link = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _propTypes, _react, _hooks, _useRouteLocation, _jsxRuntime) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Link = Link;
  _propTypes = _interopRequireDefault(_propTypes);
  var _excluded = ["as", "to", "replace", "reuse", "state", "action", "direction", "children", "onClick"];

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function Link(props) {
    var _props$to;

    var link = (0, _hooks.useLink)();
    var location = (0, _useRouteLocation.useRouteLocation)();
    var handleClick = (0, _react.useCallback)(function (event) {
      var handler = props.replace ? link.replace : link.push;
      var to = typeof props.to === 'function' ? props.to(location) : props.to;
      var result = props.onClick ? props.onClick(event) : true;
      if (result !== false && !event.shiftKey) handler(to, props.state, props, location);
      if (event.shiftKey || props.onClick && result !== undefined) return result;
      event.preventDefault();
    }, [link, props, location]);

    var as = props.as,
        to = props.to,
        replace = props.replace,
        reuse = props.reuse,
        state = props.state,
        action = props.action,
        direction = props.direction,
        children = props.children,
        onClick = props.onClick,
        aProps = _objectWithoutProperties(props, _excluded);

    var componentProps = _objectSpread(_objectSpread({}, aProps), {}, {
      onClick: handleClick
    });

    var Component = as || 'a';
    if (Component === 'a') componentProps.href = (_props$to = props.to) !== null && _props$to !== void 0 && _props$to.pathname ? props.to.pathname + props.to.search : props.to;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, _objectSpread(_objectSpread({}, componentProps), {}, {
      children: children
    }));
  }

  Link.defaultProps = {
    reuse: true
  };
  Link.propTypes = {
    as: _propTypes.default.any,
    children: _propTypes.default.any,
    to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]).isRequired,
    replace: _propTypes.default.bool,
    onClick: _propTypes.default.func,
    reuse: _propTypes.default.bool,
    state: _propTypes.default.object,
    action: _propTypes.default.string,
    direction: _propTypes.default.string
  };
});